"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment/moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'storeOnlineOrderReport',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        retailerId: '',
        retailerName: '',
        orderNo: '',
        tireOrderNo: '',
        orderCreateTimeStart: '',
        orderCreateTimeEnd: '',
        finishedTimeStart: '',
        finishedTimeEnd: ''
      },
      form: {},
      region: [],
      regionOptions: []
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var orderCreateTimeEnd = _this.searchVal.orderCreateTimeEnd;
          if (orderCreateTimeEnd) {
            var maxDate = (0, _moment.default)(orderCreateTimeEnd, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(orderCreateTimeEnd, 'YYYY-MM-DD').subtract(30, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var orderCreateTimeStart = _this.searchVal.orderCreateTimeStart;
          if (orderCreateTimeStart) {
            var minDate = (0, _moment.default)(orderCreateTimeStart, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(orderCreateTimeStart, 'YYYY-MM-DD').add(30, 'days'); // 向后30天
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    finishedStartPickerOptions: function finishedStartPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var finishedEndTime = _this.searchVal.finishedEndTime;
          if (finishedEndTime) {
            var maxDate = (0, _moment.default)(finishedEndTime, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(finishedEndTime, 'YYYY-MM-DD').subtract(30, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    finishedEndPickerOptions: function finishedEndPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var finishedStartTime = _this.searchVal.finishedStartTime;
          if (finishedStartTime) {
            var minDate = (0, _moment.default)(finishedStartTime, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(finishedStartTime, 'YYYY-MM-DD').add(30, 'days'); // 向后30天
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.searchData();
    }, 300);
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      console.log(param);
      this.listLoading = true;
      this.$api.reportModule.getStoreOnlineOrderList(param, this.sourceApi.token).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.data.items;
        _this3.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.listLoading = false;
      });
    },
    resetData: function resetData() {
      var _this4 = this;
      setTimeout(function () {
        _this4.searchVal.retailerId = '';
        _this4.searchVal.retailerName = '';
        _this4.searchVal.orderNo = '';
        _this4.searchVal.tireOrderNo = '';
        _this4.searchVal.orderCreateTimeStart = '';
        _this4.searchVal.orderCreateTimeEnd = '';
        _this4.searchVal.finishedTimeStart = '';
        _this4.searchVal.finishedTimeEnd = '';
        _this4.searchData();
      }, 300);
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    downloadExcel: function downloadExcel() {
      var _this5 = this;
      // if (!this.searchVal.startTime || !this.searchVal.endTime) {
      //   this.$message.warning(this.$t('sfe.storeonlineorderreport.input.dataHolder'))
      //   return
      // }
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.storeonlineorderreport.exportFileName');
      this.$api.reportModule.exportStoreOnlineOrderList(this.searchVal).then(function (res) {
        _this5.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this5.$message.error(_this5.$t('sfe.storeonlineorderreport.input.exportFailed'));
        console.log(err);
        _this5.isLoading = false;
      });
    }
  }
};